<template>
    <div class="modal__container">
        <div class="modal__new_order">
            <div class="modal__new_order_container">
                <div ref="svgContainer" class="modal__new_order_logo">
                </div>
                <div v-if="isQuestion" class="modal__new_order_text">
                    <div class="modal__new_order_text_info">
                        {{ __t('O.THE_ORDER_MUST_BE_READY_IN') }} {{ orderReadyTime }}
                    </div>
                    <div class="modal__new_order_text_info">
                        {{ __t('O.YOU_WILL_HAVE_TIME_TO_PREPARE_IT') }}
                    </div>
                </div>
                <div v-else class="modal__new_order_text">
                    <div class="modal__new_order_text_info">
                        {{ __t('O.ORDER_ACCEPTED') }}
                    </div>
                </div>
            </div>
            <div v-if="isQuestion" class="modal__new_order_buttons">
                <div class="modal__new_order_buttons_button cursor_pointer see" @click.prevent="clickAccept">
                    <div class="modal__new_order_buttons_button_text">
                        {{ __t('O.YES_TAKE_TO_WORK') }}
                    </div>
                </div>
                <button class="modal__new_order_buttons_button" @click.prevent="clickModalTime">
                    <div class="modal__new_order_buttons_button_text">
                        {{ __t('O.NO_NEED_MORE_TIME') }}
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {createHelpers} from "vuex-map-fields";
import insertSvg from "../../../mixins/insertSvg";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})

export default {
    name: "modal_question",
    props: {
        actionButton: {
            type: Object,
            required: true,
        }
    },
    emits: [],
    mixins: [insertSvg],
    data() {
        return {
            isQuestion: true,
        }
    },
    mounted() {
        if (this.activeItemMenuOrders && this.activeItemMenuOrders.aggregator && this.activeItemMenuOrders.aggregator.icon) {
            this.insertSvg(this.activeItemMenuOrders.aggregator.icon);
        }
    },
    methods: {
        clickModalTime() {
            EventBus.$emit('click_modal_time', this.actionButton);
        },
        clickAccept() {
            this.isQuestion = false;
            setTimeout(() => {
                EventBus.$emit('accept_the_order', {itemButton: this.actionButton, timeSelect: null});
            }, 1000);
        },
    },
    computed: {
        ...mOrders([
            'activeItemMenuOrders',
        ]),
        orderReadyTime() {
            return '';
        }
    },
}
</script>
